import { avatarInitial } from "@/domain/user";
import "./account.css";

/**
 * Avatar — 프로필 사진(있으면) 또는 이름 첫 글자.
 * 크기·색은 부르는 쪽 클래스가 정한다(헤더 .hd-account-av · 하단 탭 .mtab-av · 내 계정 .ma-av).
 * 사진은 users/{uid}/preferences/profile(useMyProfile) — 12 설계 §8-A·D-1.
 */
export function Avatar({
  photo,
  name,
  loginId,
  className,
}: {
  photo: string | null;
  name?: string | null;
  loginId?: string | null;
  className: string;
}) {
  return (
    <span className={`${className}${photo ? " ma-has-photo" : ""}`} aria-hidden="true">
      {photo ? <img className="ma-av-img" src={photo} alt="" draggable={false} /> : avatarInitial(name, loginId)}
    </span>
  );
}
